import * as React from '@wordpress/element';

const GFSVG = (props) => (
	<svg viewBox="-15 77 581 640" width={24} height={24} {...props}>
		<path
			fill="#1e1e1e"
			d="M489.5 227L315.9 126.8c-22.1-12.8-58.4-12.8-80.5 0L61.8 227c-22.1 12.8-40.3 44.2-40.3 69.7v200.5c0 25.6 18.1 56.9 40.3 69.7l173.6 100.2c22.1 12.8 58.4 12.8 80.5 0L489.5 567c22.2-12.8 40.3-44.2 40.3-69.7V296.8c0-25.6-18.1-57-40.3-69.8zM401 300.4v59.3H241v-59.3h160zM163.3 490.9c-16.4 0-29.6-13.3-29.6-29.6 0-16.4 13.3-29.6 29.6-29.6s29.6 13.3 29.6 29.6-13.3 29.6-29.6 29.6zm0-131.2c-16.4 0-29.6-13.3-29.6-29.6s13.3-29.6 29.6-29.6 29.6 13.3 29.6 29.6-13.3 29.6-29.6 29.6zM241 490.9v-59.3h160v59.3H241z"
		/>
	</svg>
);

export default GFSVG;
